import { render, staticRenderFns } from "./updateManageNotification.vue?vue&type=template&id=79d01404&scoped=true&"
import script from "./updateManageNotification.vue?vue&type=script&lang=js&"
export * from "./updateManageNotification.vue?vue&type=script&lang=js&"
import style0 from "./updateManageNotification.vue?vue&type=style&index=0&id=79d01404&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d01404",
  null
  
)

export default component.exports